// 抽查
export default [
  //任务内容配置
  {
    path: '/taskContentConfiguration',
    name: 'taskContentConfiguration',
    component: () => import( /* webpackChunkName: "spotCheck" */ '@/views/home/spotCheck/taskContentConfiguration'),
    meta: {
      activeMenu: 'taskContentConfiguration', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  // 任务列表
  {
    path: '/taskList',
    name: 'taskList',
    component: () => import( /* webpackChunkName: "spotCheck" */ '@/views/home/spotCheck/taskList'),
    meta: {
      activeMenu: 'taskList', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },

  // 自动任务列表
  {
    path: '/autoGenerateTasks',
    name: 'autoGenerateTasks',
    component: () => import( /* webpackChunkName: "spotCheck" */ '@/views/home/spotCheck/autoGenerateTasks'),
    meta: {
      activeMenu: 'autoGenerateTasks', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  // 预设任务列表
  {
    path: '/presetTaskList',
    name: 'presetTaskList',
    component: () => import( /* webpackChunkName: "spotCheck" */ '@/views/home/spotCheck/presetTaskList'),
    meta: {
      activeMenu: 'presetTaskList', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  // 商品信息记录设置
  {
    path: '/productInfoRecordSettings',
    name: 'productInfoRecordSettings',
    component: () => import( /* webpackChunkName: "spotCheck" */ '@/views/home/spotCheck/productInfoRecordSettings'),
    meta: {
      activeMenu: 'productInfoRecordSettings',
      // keepAlive: true // true 开启。
    }
  },
  // 商品信息任务
  {
    path: '/productInfoTask',
    name: 'productInfoTask',
    component: () => import( /* webpackChunkName: "spotCheck" */ '@/views/home/spotCheck/productInfoTask'),
    meta: {
      activeMenu: 'productInfoTask',
      // keepAlive: true // true 开启。
    }
  },
]